import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { Observable, map, of, startWith } from 'rxjs';
import { SharedModule } from '../../../core/shared.module';
import { tipologicaInterface } from '../../../interfaces/tipologica.interface';

@Component({
  selector: 'app-autocomplete',
  standalone: true,
  imports: [
    SharedModule,
    FormsModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    AsyncPipe,
  ],
  templateUrl: './autocomplete.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutocompleteComponent {
  @Input() _formControl: FormControl = new FormControl();
  @Input() fullTitle: boolean = false;
  @Input() _list: tipologicaInterface[] = [];
  @Input() _placeholder: string = '';
  _listFiltered: Observable<any[]> = of();

  constructor() {}

  ngOnChanges(event: any) {
    this._listFiltered = this._formControl.valueChanges.pipe(
      startWith(''),
      map((value: any) => {
        if (typeof value === 'string') {
          return this.filterOptionsByLabel(this._list, value);
        }
        return this._list;
      })
    );
  }

  filterOptionsByLabel(options: tipologicaInterface[], label: string): any[] {
    const value = label.trim().toLowerCase();

    // Filtra gli elementi che iniziano con il valore
    const startsWithValue = options.filter((option: tipologicaInterface) => {
      return option?.descrizione?.toLowerCase().startsWith(value);
    });

    // Filtra gli elementi che contengono il valore ma non iniziano con esso
    const containsValue = options.filter((option: tipologicaInterface) => {
      return (
        option?.descrizione?.toLowerCase().includes(value) &&
        !option?.descrizione?.toLowerCase().startsWith(value)
      );
    });

    // Filtra gli elementi il cui id inizia con il valore
    const startsWithId = options.filter((option: tipologicaInterface) => {
      return option?.id?.toString().toLowerCase().startsWith(value);
    });

    // Filtra gli elementi il cui id contiene il valore ma non inizia con esso
    const containsId = options.filter((option: tipologicaInterface) => {
      return (
        option?.id?.toString().toLowerCase().includes(value) &&
        !option?.id?.toString().toLowerCase().startsWith(value)
      );
    });

    // Combina i risultati
    if (!this.fullTitle) {
      return [...startsWithValue, ...containsValue];
    } else {
      return Array.from(new Set([...startsWithId, ...containsId, ...startsWithValue, ...containsValue]));
    }
  }

  getTitle(_item: tipologicaInterface): any {
    const item = this._list.find((item) => item.id === _item?.id);
    if (item) {
      return this.fullTitle ? item?.id + ' - ' + item?.descrizione : item.descrizione;
    }
    return '';
  }
}
